import {
  CheckIn_CheckInItemIssuesFieldsFragment,
  CheckIn_CheckInItemsFieldsFragment,
  CheckIn_CheckInItemsQuery,
  CheckIn_CompleteOrderInvoiceCheckInMutation,
} from '@/types';
import { DataProxy, FetchResult } from '@apollo/client';
import { ItemListOption } from './item-context-types';
import { ScannerType, ScanSound } from '@/components/scanner/scanner-types';

export enum CheckInFilters {
  ALL = 'ALL',
  FULLY_RECEIVED = 'FULLY_RECEIVED',
  HAS_ISSUES = 'HAS_ISSUES',
  NOT_FULFILLED = 'NOT_FULFILLED',
  PARTIAL_OR_MISSING = 'PARTIAL_OR_MISSING',
}

export type FilteredCheckInItemUUIDMap = Record<CheckInFilters, Set<string>>;
export type CheckItemQuantityMap = Record<string, number>;
export type CheckIssuesAmountMap = Record<string, number>;

export interface CheckInItem {
  amountOfIssues: number;
  checkInItemUUID: string;
  checkInUUID: string;
  currencyCode: string;
  issues?: CheckIn_CheckInItemIssuesFieldsFragment[];
  manufacturerSuggestedRetailPriceInMicros?: number | null;
  priceInMicros: number;
  shipQuantity: number;
  suggestedRetailPriceInMicros?: number | null;
  title: string;
  variantPack?: ItemListOption | null;
}

export interface ProblematicItemsMetrics {
  cost: number;
  missing: number;
  withIssues: number;
}

export interface CheckInContextType {
  adaptCheckInItemFragment: (
    checkInItem: CheckIn_CheckInItemsFieldsFragment,
  ) => CheckInItem;
  autoIncrementQuantity: (checkInItem: CheckInItem) => void;
  clearSearchResults: () => void;
  completeCheckIn: () => Promise<
    FetchResult<CheckIn_CompleteOrderInvoiceCheckInMutation>
  >;
  currencyCode: string;
  filteredCheckInItems?: CheckIn_CheckInItemsFieldsFragment[];
  filteredIdsMap: FilteredCheckInItemUUIDMap;
  itemQuantityMap: CheckItemQuantityMap;
  loading: boolean;
  onItemQuantityUpdate: (itemUUID: string, quantity: number) => void;
  playScanSound: (scanSound: ScanSound) => Promise<void>;
  problematicItemsMetrics?: ProblematicItemsMetrics;
  refetchCheckInQuery: () => Promise<FetchResult<CheckIn_CheckInItemsQuery>>;
  refreshOnDeleteIssue: (
    client: DataProxy,
    checkInItemUUID: string,
    issueUUIDs: string[],
  ) => void;
  refreshOnReportIssue: (
    client: DataProxy,
    checkInItemUUID: string,
    item?: CheckIn_CheckInItemsFieldsFragment | null,
  ) => void;
  saveCheckInChanges: () => Promise<void>;
  searchForItems: (
    code: string,
    scannerType: ScannerType,
  ) => CheckIn_CheckInItemsFieldsFragment[];
  searchResults: CheckIn_CheckInItemsFieldsFragment[] | null;
  selectedFilter: CheckInFilters;
  setSelectedFilter: (filter: CheckInFilters) => void;
  shippedItems?: CheckIn_CheckInItemsFieldsFragment[];
  totalShippedQuantity: number;
}
